import { BACKEND_URL_UNCONFIGURED } from "../lib/api";

/**
 * Configuration warning banner — currently disabled by product decision
 * because the relative `/api` fallback in `lib/api.js` works transparently
 * for same-origin production deploys. The console warning in `lib/api.js`
 * still fires so ops can spot misconfigured builds in devtools.
 *
 * To re-enable the visible banner, uncomment the block below.
 */
export default function BackendUrlBanner() {
  // Preserve the flag reference so bundlers keep the import wired.
  void BACKEND_URL_UNCONFIGURED;
  return null;
}
